import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ASSETS } from "@/lib/brand";

const links = [
  { to: "/", label: "Index", testId: "nav-home" },
  { to: "/about", label: "About", testId: "nav-about" },
  { to: "/ventures", label: "Ventures", testId: "nav-ventures" },
  { to: "/projects", label: "Projects", testId: "nav-projects" },
  { to: "/journal", label: "Journal", testId: "nav-journal" },
  { to: "/contact", label: "Contact", testId: "nav-contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#050A15]/75 border-b hairline" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto flex items-center justify-between px-6 md:px-12 py-5">
        <Link to="/" data-testid="nav-logo" className="flex items-center group">
          <img
            src={ASSETS.monogram}
            alt="Miguel Santana"
            className="h-12 md:h-14 w-auto object-contain transition-opacity duration-300 group-hover:opacity-80"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              end={l.to === "/"}
              className={({ isActive }) =>
                `font-overline transition-colors duration-300 ${
                  isActive ? "text-silver" : "text-silver-muted hover:text-silver"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta-inquiry"
            className="btn-editorial btn-editorial-filled"
          >
            <span>Book / Inquire</span>
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-silver p-2"
        >
          <div className="w-6 h-px bg-silver mb-1.5"></div>
          <div className="w-6 h-px bg-silver mb-1.5"></div>
          <div className="w-4 h-px bg-silver ml-auto"></div>
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#050A15]/95 backdrop-blur-xl border-t hairline">
          <div className="px-6 py-8 flex flex-col gap-6">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-${l.testId}`}
                className={({ isActive }) =>
                  `font-display text-2xl ${isActive ? "text-silver" : "text-silver-muted"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" className="btn-editorial btn-editorial-filled mt-4" data-testid="mobile-nav-cta-inquiry">
              Book / Inquire
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
